import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
import ProductCard from '@/components/common/ProductCard';

export const ProductRail = ({ title, eyebrow, products = [], viewAll, testId }) => {
  const ref = useRef(null);
  if (!products || products.length === 0) return null;
  const scroll = (dir) => {
    if (ref.current) ref.current.scrollBy({ left: dir * 320, behavior: 'smooth' });
  };
  return (
    <section className="container-gaze py-10 sm:py-14" data-testid={testId}>
      <div className="mb-6 flex items-end justify-between">
        <div>
          {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
          <h2 className="text-2xl font-semibold tracking-tight sm:text-3xl">{title}</h2>
        </div>
        <div className="flex items-center gap-2">
          {viewAll && (
            <Link to={viewAll} className="hidden items-center gap-1 text-sm font-semibold text-[hsl(var(--primary))] hover:gap-2 sm:flex">
              View all <ArrowRight size={16} />
            </Link>
          )}
          <button onClick={() => scroll(-1)} className="grid h-9 w-9 place-items-center rounded-full border border-border bg-white hover:hairline-gold" aria-label="Scroll left">
            <ChevronLeft size={18} />
          </button>
          <button onClick={() => scroll(1)} className="grid h-9 w-9 place-items-center rounded-full border border-border bg-white hover:hairline-gold" aria-label="Scroll right">
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
      <div ref={ref} className="no-scrollbar -mx-1 flex snap-x gap-4 overflow-x-auto px-1 pb-2">
        {products.map((p, i) => (
          <div key={p.id} className="w-[46%] shrink-0 snap-start sm:w-[30%] lg:w-[23%]">
            <ProductCard product={p} index={i} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductRail;
